import React from 'react';
import { connect } from 'react-redux'
import SaldosResumenes from './SaldosResumenes';

//Importación de actions.
import {
    resetState,
    getScreenData,
    getCuentaCorrienteData,
    getCuotasPendientes,
    toggleTotalCuotasPendientes
} from '../actions/SaldosResumenesActions';

//Mapeo del state
const mapStateToProps = (state) => {
    let result = {
        data: state.saldosResumenes.data,
        vistaCliente: state.vistaCliente.data
    }
}

//Mapeo de las actions en las props
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        resetState: () => {
            dispatch(resetState());
        },
        getScreenData: (currentScope, currentAccount) => {
            dispatch(getScreenData(currentScope, currentAccount));
        },
        getCuotasPendientes: (cuentaTarjetaId, fechaCierreMin, fechaCierreMax, fechaHoy) => {
            dispatch(getCuotasPendientes(cuentaTarjetaId, fechaCierreMin, fechaCierreMax, fechaHoy));
        },
        toggleTotalCuotasPendientes: () => {
            dispatch(toggleTotalCuotasPendientes());
        },
        getCuentaCorrienteData: (cuentaTarjetaId, fechaCierre, ...params) => {
            dispatch(getCuentaCorrienteData(cuentaTarjetaId, fechaCierre, ...params))
        }
    }
}

//Connect entre el componente y las props y actions.
const SaldosResumenesContainer = connect(mapStateToProps, mapDispatchToProps)(SaldosResumenes);

export default SaldosResumenesContainer;